import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import SvgIcon from "@mui/material/SvgIcon";
import ColorLensIcon from '@mui/icons-material/ColorLens';
import { LENGTH } from '../helper/Icons';
import {formatNumber} from "../helper/utils";


const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function ModelProductCard(props) {
	const [expanded, setExpanded] = React.useState(false);
	const { t, i18n } = useTranslation("",{lng: props.language});

  	const handleExpandClick = () => {
    	setExpanded(!expanded);
  	};

  	return (
		<Card sx={{minWidth: {   xs: '240px',
												sm: '240px',  
												md: '240px',  
												lg: '240px',  
												xl: '240px',  																		
												},		
				   maxWidth: {   xs: '360px',
												sm: '360px'
												}												
				}}
		>
	    	<CardHeader title={props.item.label}
	        			subheader={props.item.slogan}
			/>

	      	{props.item.image ? ( 
				<picture>
					{props.item.image.map((image)  => (			
						<img src={image.src}/>
					))}
				</picture>
				) : (<></>)
			}
			<CardContent>
          			<Typography paragraph>{t("Zusatzinfo")}:</Typography>
          			<Typography paragraph>
						{props.item.description}
          			</Typography>
	          		<Typography paragraph>{t("Standard Lackierung")}:</Typography>
          			<Typography paragraph>
		 				<ul class="empty" style={{listStyleType: "none", marginLeft: "20px"}}>
							<li><ColorLensIcon/>{t("Weiß")}</li>
						</ul>
					</Typography>	
	          		<Typography paragraph>{t("Liegefläche")}:</Typography>
          			<Typography paragraph>
		 				<ul class="empty" style={{listStyleType: "none", marginLeft: "20px"}}>
							<li><SvgIcon><LENGTH/></SvgIcon>{props.item.length + "cm"}</li>
							<li><SvgIcon><LENGTH/></SvgIcon>{props.item.width + "cm"}</li>
						</ul>
					</Typography>	
		  		<Stack  direction="row" justifyContent="space-between" alignItems="center">
	        		<Typography gutterBottom variant="body2" component="div">
	            		{props.item.included == "true" ? (
							<></>
						) : (
							<Checkbox 	data-type="carRoofs" 
								checked={props.checked}
								onClick={e => props.changeItem(e, props.uuid, props.currentArtnr)} />
						)}
	          		</Typography>
	          		<Typography gutterBottom variant="h6" component="div">
	          			{formatNumber("de_DE", props.item.price)}
	          		</Typography>
	        	</Stack>
			</CardContent>

      </Card>
  );
}